import { graphql } from "./generated/gql";

export const TemplateQuery = graphql(`
  query Template($templateId: ID!) {
    template(templateId: $templateId) {
      templateId
      termId
      createdAt
      updatedAt
    }
  }
`);

export const TermTemplateQuery = graphql(`
  query TermTemplate($termId: ID!) {
    termTemplate(termId: $termId) {
      templateId
      termId
      createdAt
      updatedAt
    }
  }
`);

export const TemplateItemsQuery = graphql(`
  query TemplateItems($templateId: ID!) {
    templateItems(templateId: $templateId) {
      nodes {
        templateItemId
        templateId
        category
        timeEstimate
        itemName
        question
        note
        isRequired
        order
        createdAt
        updatedAt
      }
      totalCount
    }
  }
`);

export const CreateTemplateItemMutation = graphql(`
  mutation CreateTemplateItem($input: CreateTemplateItemInput!) {
    createTemplateItem(input: $input) {
      templateItemId
      templateId
      category
      timeEstimate
      itemName
      question
      note
      isRequired
      order
      createdAt
      updatedAt
    }
  }
`);

export const UpdateTemplateItemMutation = graphql(`
  mutation UpdateTemplateItem($input: UpdateTemplateItemInput!) {
    updateTemplateItem(input: $input) {
      templateItemId
      templateId
      category
      timeEstimate
      itemName
      question
      note
      isRequired
      order
      createdAt
      updatedAt
    }
  }
`);

export const DeleteTemplateItemMutation = graphql(`
  mutation DeleteTemplateItem($templateItemId: ID!) {
    deleteTemplateItem(templateItemId: $templateItemId)
  }
`);

export const BulkCreateTemplateItemsMutation = graphql(`
  mutation BulkCreateTemplateItems($input: BulkCreateTemplateItemsInput!) {
    bulkCreateTemplateItems(input: $input) {
      nodes {
        templateItemId
        templateId
        category
        timeEstimate
        itemName
        question
        note
        isRequired
        order
        createdAt
        updatedAt
      }
      totalCount
    }
  }
`);
